// Widget configuration using environment variables

export const config = {
  // Supabase
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || 'https://your-project.supabase.co',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || 'your-anon-key',
  
  // Widget
  projectId: import.meta.env.VITE_PROJECT_ID || 'demo-project',
  version: import.meta.env.VITE_WIDGET_VERSION || '1.0.0',
  
  // Development
  isDevelopment: import.meta.env.VITE_DEV_MODE === 'true',
  isDebugMode: import.meta.env.VITE_DEBUG === 'true',
} as const

// Helper function to log debug information
export function debugLog(message: string, data?: any) {
  if (config.isDebugMode) {
    console.log(`[FeedLet Debug] ${message}`, data || '')
  }
}

// Helper function to get environment info
export function getEnvironmentInfo() {
  return {
    version: config.version,
    isDevelopment: config.isDevelopment,
    isDebugMode: config.isDebugMode,
    supabaseUrl: config.supabaseUrl,
    // Don't expose the actual key, just whether it's set
    hasSupabaseKey: !!config.supabaseAnonKey && config.supabaseAnonKey !== 'your-anon-key',
  }
}

// Validation function
export function validateConfig() {
  const warnings: string[] = []
  
  if (config.supabaseUrl === 'https://your-project.supabase.co') {
    warnings.push('VITE_SUPABASE_URL is not set - using default placeholder')
  }
  
  if (config.supabaseAnonKey === 'your-anon-key') {
    warnings.push('VITE_SUPABASE_ANON_KEY is not set - using default placeholder')
  }
  
  if (warnings.length > 0 && config.isDebugMode) {
    console.warn('[FeedLet Config] Configuration warnings:', warnings)
  }
  
  return warnings
} 